var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RequestClient } from "../basics/request-client.service";
import { autoinject } from "aurelia-framework";
import { TokenClient } from "../authentication/token-client.service";
import { Api } from "../../constants/modules/api.constants";
import { toNative } from "../../utilities/promise-utils";
var OperatorClientService = /** @class */ (function () {
    function OperatorClientService(requestClient, tokenClient) {
        this.requestClient = requestClient;
        this.tokenClient = tokenClient;
    }
    OperatorClientService.prototype.getOperator = function (request) {
        return toNative(this.requestClient.get(Api.ManageOperators.Get, request));
    };
    OperatorClientService.prototype.save = function (request) {
        return toNative(this.requestClient.post(Api.ManageOperators.Save, {}, request));
    };
    OperatorClientService.prototype.getInsurancePolicies = function (operatorId) {
        return toNative(this.requestClient.post(Api.ManageOperators.GetInsurancePolicies, {}, operatorId));
    };
    OperatorClientService.prototype.delete = function (request) {
        return toNative(this.requestClient.post(Api.ManageOperators.Delete, {}, request));
    };
    OperatorClientService.prototype.cloneCheck = function (request) {
        return toNative(this.requestClient.post(Api.ManageOperators.CloneCheck, {}, request));
    };
    OperatorClientService.prototype.clone = function (request) {
        return toNative(this.requestClient.post(Api.ManageOperators.Clone, {}, request));
    };
    OperatorClientService.prototype.topup = function (operatorId, topUpAmount) {
        return toNative(this.requestClient.post("".concat(Api.ManageOperators.Topup, "/").concat(operatorId), {}, {
            amount: topUpAmount
        }));
    };
    OperatorClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient, TokenClient])
    ], OperatorClientService);
    return OperatorClientService;
}());
export { OperatorClientService };
